
import PageHeader from '../components/PageHeader';
import Footer from '../components/Footer';

import OrderStatus from '../components/OrderStatus';

import food from '../images/food.jpg';
import beverages from '../images/beverages.jpg';
import desserts from '../images/desserts.jpg';

export default function Menu() {
    return(
        <div className="container-fluid p-0 mt-4 mb-0">

            <PageHeader/>

            <div className="container">

              {/* breadcumb */}
              <div className="row">
                <div className="col-12">
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0">
                      <li class="breadcrumb-item"><a href="/">Home</a></li>
                      <li class="breadcrumb-item active" aria-current="page">View Menu</li>
                    </ol>
                  </nav>
                </div>
              </div>
              {/* breadcumb */}

              {/* order status box */}
              <div className="row">
                <OrderStatus/>
              </div>
              {/* order status box */}

              <a href='/menu-sub'>
                 <div className="bg-white mb-4 p-3 rounded-3 d-flex">
                  
                  <div className="d-flex align-items-center">
                    <img src={food} alt='' className='d-block' style={{ width: '70px' }}></img>
                  </div>
                  
                   <div className='d-flex align-items-center pe-1' style={{ minWidth: '200px', flexWrap: 'wrap' }}>
                    <h1 className='sub_heading mb-0 w-100'>Food</h1>
                    <p className='mb-0 w-100'>
                      Sandwiches, Croissant Sandwiches, Bagels, Garlic Breads
                    </p>
                  </div>

                  <div className='d-flex align-items-center' style={{ borderLeft: '1px solid #F06341' }}>
                    <svg className='ms-2' width="21" height="10" viewBox="0 0 21 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.1133 5.42194C20.3463 5.18891 20.3463 4.81109 20.1133 4.57806L16.3159 0.780639C16.0828 0.54761 15.705 0.54761 15.472 0.780639C15.239 1.01367 15.239 1.39148 15.472 1.62451L18.8475 5L15.472 8.37549C15.239 8.60852 15.239 8.98633 15.472 9.21936C15.705 9.45239 16.0828 9.45239 16.3159 9.21936L20.1133 5.42194ZM0 5V5.59671H19.6914V5V4.40329H0V5Z" fill="black"/>
                    </svg>
                  </div>

                </div>
              </a>
             
              {/* ==================== */}

               <a href='/menu-sub'>
                 <div className="bg-white mb-4 p-3 rounded-3 d-flex">
                  
                 <div className="d-flex align-items-center">
                    <img src={beverages} alt='' className='d-block' style={{ width: '70px' }}></img>
                  </div>

                 <div className='d-flex align-items-center pe-1' style={{ minWidth: '200px', flexWrap: 'wrap' }}>
                    <h1 className='sub_heading mb-0 w-100'>BEVERAGES</h1>
                    <p className='mb-0'>
                      Hot Coffee, Cold Coffee, Cold Brew, Sweet Tornadoes, Smoothies, Fizzy Drinks, Fruit Juice, Iced Drinks, Crushes 
                    </p>
                  </div>

                  <div className='d-flex align-items-center' style={{ borderLeft: '1px solid #F06341' }}>
                    <svg className='ms-2' width="21" height="10" viewBox="0 0 21 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.1133 5.42194C20.3463 5.18891 20.3463 4.81109 20.1133 4.57806L16.3159 0.780639C16.0828 0.54761 15.705 0.54761 15.472 0.780639C15.239 1.01367 15.239 1.39148 15.472 1.62451L18.8475 5L15.472 8.37549C15.239 8.60852 15.239 8.98633 15.472 9.21936C15.705 9.45239 16.0828 9.45239 16.3159 9.21936L20.1133 5.42194ZM0 5V5.59671H19.6914V5V4.40329H0V5Z" fill="black"/>
                    </svg>
                  </div>

                </div>
              </a>
             
              {/* ==================== */}

               <a href='/menu-sub'>
                 <div className="bg-white mb-4 p-3 rounded-3 d-flex">
                  
                  <div className="d-flex align-items-center">
                    <img src={desserts} alt='' className='d-block' style={{ width: '70px' }}></img>
                  </div>

                  <div className='d-flex align-items-center pe-1' style={{ minWidth: '200px', flexWrap: 'wrap' }}>
                    <h1 className='sub_heading mb-0 w-100'>DESSERTS</h1>
                    <p className='mb-0'>
                      Cheese cakes, Brownies, Muffin
                    </p>
                  </div>

                  <div className='d-flex align-items-center' style={{ borderLeft: '1px solid #F06341' }}>
                    <svg className='ms-2' width="21" height="10" viewBox="0 0 21 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.1133 5.42194C20.3463 5.18891 20.3463 4.81109 20.1133 4.57806L16.3159 0.780639C16.0828 0.54761 15.705 0.54761 15.472 0.780639C15.239 1.01367 15.239 1.39148 15.472 1.62451L18.8475 5L15.472 8.37549C15.239 8.60852 15.239 8.98633 15.472 9.21936C15.705 9.45239 16.0828 9.45239 16.3159 9.21936L20.1133 5.42194ZM0 5V5.59671H19.6914V5V4.40329H0V5Z" fill="black"/>
                    </svg>
                  </div>

                </div>
              </a>
             
              {/* ==================== */}

              

            </div>

           <Footer/>
        </div>
    );
};